import { VisualizationPlane } from './types';

export const SWING_PLANE_KEYS = {
    SETUP_PLANE: 'SETUP_PLANE',
    IMPACT_PLANE: 'IMPACT_PLANE',
    SWING_PLANE: 'SWING_PLANE',
    TRAIL_ELBOW_PLANE: 'TRAIL_ELBOW_PLANE',
    TRAIL_SHOULDER_PLANE: 'TRAIL_SHOULDER_PLANE',
} as const;

export const SWING_PLANES: Record<string, VisualizationPlane> = {
    [SWING_PLANE_KEYS.SETUP_PLANE]: {
        label: 'Shaft plane at setup',
        type: 'plane',
        id: SWING_PLANE_KEYS.SETUP_PLANE,
    },
    [SWING_PLANE_KEYS.IMPACT_PLANE]: {
        label: 'Shaft plane at impact',
        type: 'plane',
        id: SWING_PLANE_KEYS.IMPACT_PLANE,
    },
    [SWING_PLANE_KEYS.SWING_PLANE]: {
        label: 'Swing plane',
        type: 'plane',
        id: SWING_PLANE_KEYS.SWING_PLANE,
    },
    [SWING_PLANE_KEYS.TRAIL_ELBOW_PLANE]: {
        label: 'Trail elbow plane at setup',
        type: 'plane',
        id: SWING_PLANE_KEYS.TRAIL_ELBOW_PLANE,
    },
    [SWING_PLANE_KEYS.TRAIL_SHOULDER_PLANE]: {
        label: 'Trail shoulder plane at setup',
        type: 'plane',
        id: SWING_PLANE_KEYS.TRAIL_SHOULDER_PLANE,
    },
};

export const SWING_PLANES_LIST = Object.keys(SWING_PLANES);
